/* [ECOMHARD] Definer grátis — BLACK VIP, versão 8.
 * O link apenas ativa o popup. Produto brinde custa R$ 0,00 e NENHUM cupom é aplicado.
 * Os dados do produto não listado são carregados pelo Ajax Product API da Shopify;
 * falhas no lookup do produto NÃO bloqueiam a identificação VIP nem o gatilho.
 */
(() => {
  "use strict";
  if (window.__ecomhardDefinerVipInitialized) return;

  const rootElement = document.getElementById("ecomhard-definer-vip");
  const configElement = document.getElementById("ecomhard-definer-vip-config");
  if (!rootElement || !configElement) return;

  let config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error("[ECOMHARD] Definer grátis: configuração inválida.", error);
    return;
  }

  // A V7 abortava AQUI se o all_products não resolvesse o brinde. Isso também
  // impedia o reconhecimento do link VIP e fazia o modal sumir silenciosamente.
  window.__ecomhardDefinerVipInitialized = true;
  config.balmHandle = config.balmHandle || "lumni-lip-balm";
  config.giftHandle = config.giftHandle || config.giftHandleRequested ||
    config.giftHandleResolved || "lip-definer-brinde-vipblack";
  config.referenceHandle = config.referenceHandle || "lip-definer";
  config.variants = Array.isArray(config.variants) ? config.variants : [];
  config.swatches = Array.isArray(config.swatches) ? config.swatches : [];

  const campaignId = "eternal_black_vip"; // Identificação interna, NÃO é um cupom.
  const activeKey = "ecomhard:definer-vip:active:" + campaignId;
  const dismissedKey = "ecomhard:definer-vip:dismissed:" + campaignId;
  const currentUrl = new URL(window.location.href);
  const visitedViaLink = currentUrl.searchParams.get("eternal_black_vip") === "1";
  const storage = {
    get(key) {
      try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
    },
    set(key, value) {
      try { window.sessionStorage.setItem(key, value); return true; } catch (_) { return false; }
    },
    remove(key) {
      try { window.sessionStorage.removeItem(key); } catch (_) { /* Navegação privada. */ }
    },
  };

  // O acesso ao link VIP ativa a campanha nesta sessão, sem redirecionamento.
  if (visitedViaLink) {
    storage.set(activeKey, "1");
    storage.remove(dismissedKey);
  }
  const campaignActive = () => visitedViaLink || storage.get(activeKey) === "1";
  // Mantém o módulo inicializado mesmo fora do link, útil para diagnóstico.
  // Somente campaignActive() pode abrir o pop-up.

  const shopRoot = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");

  const routes = {
    cart: `${shopRoot}cart.js`,
    add: `${shopRoot}cart/add.js`,
    change: `${shopRoot}cart/change.js`,
    cartPage: `${shopRoot}cart`,
  };
  const elements = {
    dialog: rootElement.querySelector(".ecomhard-definer-vip__dialog"),
    colors: rootElement.querySelector("[data-eh-definer-colors]"),
    radios: Array.from(rootElement.querySelectorAll('input[name="ecomhard-definer-vip-variant"]')),
    color: rootElement.querySelector("[data-eh-definer-color]"),
    price: rootElement.querySelector("[data-eh-definer-price]"),
    image: rootElement.querySelector("[data-eh-definer-image]"),
    button: rootElement.querySelector("[data-eh-definer-add]"),
    error: rootElement.querySelector("[data-eh-definer-error]"),
    closeButtons: rootElement.querySelectorAll("[data-eh-definer-close]"),
  };
  const variantsById = new Map();
  let giftDataSource = "não carregado";
  let giftError = "";
  let giftLoading = false;
  let lastErrorMessage = "";
  let referenceVariants = [];

  const normalizeHandle = (value) => String(value || "")
    .split("/products/").pop().split("?")[0].split("#")[0].replace(/^\/+|\/+$/g, "").trim();
  config.giftHandle = normalizeHandle(config.giftHandle);
  config.balmHandle = normalizeHandle(config.balmHandle);
  config.referenceHandle = normalizeHandle(config.referenceHandle);

  const assetImageUrl = (value) => {
    if (!value) return null;
    const src = typeof value === "string" ? value : (value.src || value.url || "");
    if (!src) return null;
    return src.startsWith("//") ? `https:${src}` : src;
  };
  const formatMoney = (cents) => {
    if (!Number.isFinite(Number(cents)) || Number(cents) <= 0) return "";
    try {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency", currency: config.currency || "BRL"
      }).format(Number(cents) / 100);
    } catch (_) { return `R$ ${(Number(cents) / 100).toFixed(2).replace(".", ",")}`; }
  };
  const matchingReferencePrice = (variant) => {
    const name = String(variant.option1 || variant.name || variant.title || "").trim().toLowerCase();
    const found = referenceVariants.find((item) =>
      String(item.option1 || item.title || "").trim().toLowerCase() === name);
    return found && Number(found.price) > 0 ? Number(found.price) : 0;
  };
  const setModalMessage = (message) => {
    lastErrorMessage = message || "";
    if (elements.error) {
      elements.error.textContent = message || configuredErrorMessage;
      elements.error.hidden = !message;
    }
  };

  // A consulta Ajax evita depender do limite all_products da página, do seletor
  // de produto da Shopify ou de um handle salvo em settings_data.json.
  const getProduct = async (handle) => {
    if (!handle) throw new Error("Handle do produto não informado.");
    const response = await fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`, {
      credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error(`Produto ${handle}: HTTP ${response.status}`);
    return response.json();
  };

  const renderSwatches = () => {
    if (!elements.colors) return;
    elements.colors.replaceChildren();
    elements.radios = [];
    for (const variant of config.variants) {
      const wrapper = document.createElement("div");
      wrapper.className = "m-product-option--node ecomhard-definer-vip__color-node";
      const swatchWrap = document.createElement("div");
      swatchWrap.className = "m-product-option--swatch";
      const input = document.createElement("input");
      input.className = "ecomhard-definer-vip__radio";
      input.type = "radio";
      input.name = "ecomhard-definer-vip-variant";
      input.id = `ecomhard-definer-vip-${variant.id}`;
      input.value = String(variant.id);
      input.setAttribute("aria-label", variant.name);
      input.disabled = !variant.available;
      const label = document.createElement("label");
      label.className = "m-product-option--node__label ecomhard-definer-vip__swatch";
      label.setAttribute("data-option-type", "color");
      label.htmlFor = input.id;
      label.title = variant.name;
      label.textContent = variant.name;
      const swatch = config.swatches.find((item) =>
        String(item.name || "").trim().toLowerCase() === String(variant.name).trim().toLowerCase());
      const imageUrl = (swatch && swatch.url) || variant.swatchImage || variant.image;
      if (imageUrl) label.style.backgroundImage = `url("${String(imageUrl).replace(/"/g, "%22")}")`;
      swatchWrap.append(input, label);
      wrapper.append(swatchWrap);
      elements.colors.append(wrapper);
      elements.radios.push(input);
    }
  };

  const setVariants = (variants, source) => {
    config.variants = variants;
    variantsById.clear();
    variants.forEach((item) => variantsById.set(String(item.id), item));
    giftDataSource = source;
    renderSwatches();
    clearSelection();
    if (activeModal) updateModalAvailability();
  };

  const updateModalAvailability = () => {
    const hasAvailable = config.variants.some((variant) => variant.available);
    if (giftLoading && !hasAvailable) {
      setModalMessage("Carregando as cores do Lip Definer...");
    } else if (!hasAvailable) {
      setModalMessage(giftError || "Não encontramos variantes disponíveis a R$ 0,00 neste brinde.");
    } else {
      setModalMessage("");
    }
  };

  // Dados Liquid são um fallback. A prioridade é o produto informado no handle.
  const initialLiquid = config.variants.map((variant) => ({
    ...variant,
    name: variant.name || "Cor",
    available: Boolean(variant.available) && Number(variant.priceCents) === 0
  }));
  // Não confiar em Liquid quando o handle lido difere do brinde escolhido.
  const liquidMatches = config.giftHandleResolved === config.giftHandle;
  config.variants = liquidMatches ? initialLiquid : [];
  if (liquidMatches && initialLiquid.length) {
    initialLiquid.forEach((v) => variantsById.set(String(v.id), v));
    giftDataSource = "Liquid";
  }

  const loadGiftData = async () => {
    if (!campaignActive()) return;
    giftLoading = true;
    giftError = "";
    if (activeModal) updateModalAvailability();
    try {
      const gift = await getProduct(config.giftHandle);
      if (!gift || !gift.id || !Array.isArray(gift.variants)) throw new Error("Dados do brinde inválidos.");
      config.giftProductId = gift.id;
      let refProduct = null;
      try { refProduct = await getProduct(config.referenceHandle); } catch (_) { /* Preço riscado opcional. */ }
      referenceVariants = refProduct?.variants || [];
      const normalized = gift.variants.map((variant) => {
        const original = Number(variant.compare_at_price) > 0
          ? Number(variant.compare_at_price) : matchingReferencePrice(variant);
        return {
          id: variant.id,
          name: variant.option1 || variant.title || "Cor",
          priceCents: Number(variant.price),
          priceFormatted: formatMoney(original),
          available: Boolean(variant.available) && Number(variant.price) === 0,
          image: assetImageUrl(variant.featured_image) || assetImageUrl(gift.featured_image)
        };
      });
      setVariants(normalized, "Shopify Ajax");
      const image = assetImageUrl(gift.featured_image);
      if (elements.image && image && !elements.image.getAttribute("src")) {
        elements.image.src = image;
        elements.image.hidden = false;
      }
      if (!normalized.some((variant) => variant.available)) {
        giftError = "O produto de brinde existe, mas nenhuma variante está disponível a R$ 0,00. Confira preços e estoque.";
      }
    } catch (error) {
      giftError = `Não foi possível carregar ${config.giftHandle}: ${error.message}`;
      console.warn("[ECOMHARD] Definer grátis:", giftError);
      if (liquidMatches && initialLiquid.length) setVariants(initialLiquid, "Liquid (fallback)");
    } finally {
      giftLoading = false;
      if (activeModal) updateModalAvailability();
      scheduleSync(80);
    }
  };

  const configuredErrorMessage = elements.error.textContent.trim();
  let selectedVariant = null;
  let lastFocusedElement = null;
  let syncing = false;
  let adding = false;
  let activeModal = false;
  let pendingSync = false;
  let syncTimer = null;
  let lastQualified = null;
  let dismissedThisPage = storage.get(dismissedKey) === "1";

  const notification = (message) => {
    if (window.MinimogTheme?.Notification?.show) {
      window.MinimogTheme.Notification.show({ target: document.body, type: "warning", message, last: 4500 });
    } else {
      window.alert(message);
    }
  };

  const fetchCart = async () => {
    const response = await fetch(routes.cart, {
      method: "GET", credentials: "same-origin", cache: "no-store",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error(`Falha ao consultar carrinho (${response.status}).`);
    return response.json();
  };

  const postCart = async (url, body) => {
    const response = await fetch(url, {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      let detail = "";
      try {
        const json = await response.json();
        detail = json.description || json.message || "";
      } catch (_) { /* A mensagem HTTP já é suficiente. */ }
      throw new Error(detail || `Falha ao atualizar carrinho (${response.status}).`);
    }
    return response.json();
  };

  const balmQty = (cart) => (cart.items || []).reduce((sum, item) => {
    const matchedId = config.balmProductId && Number(item.product_id) === Number(config.balmProductId);
    const matchedHandle = String(item.handle || "").toLowerCase() === config.balmHandle.toLowerCase();
    const matchedUrl = String(item.url || "").includes(`/products/${config.balmHandle}`);
    return (matchedId || matchedHandle || matchedUrl) ? sum + Number(item.quantity || 0) : sum;
  }, 0);

  const giftItems = (cart) => (cart.items || []).filter((item) =>
    item.properties && [campaignId, "BLACKVIP-2BALMS+DEFINER"].includes(
      String(item.properties._ecomhard_definer_vip || "")) &&
    (!config.giftProductId || Number(item.product_id) === Number(config.giftProductId)));

  const refreshCartUI = async (cart, openDrawer = false) => {
    const drawer = document.querySelector("m-cart-drawer");
    if (drawer && typeof drawer.onCartDrawerUpdate === "function") {
      try {
        await drawer.onCartDrawerUpdate(true);
      } catch (error) {
        console.warn("[ECOMHARD] Definer grátis: não foi possível atualizar o drawer.", error);
      }
    }
    document.querySelectorAll(".m-cart-count-bubble").forEach((el) => {
      if (cart.item_count > 0) {
        el.textContent = cart.item_count;
        el.classList.remove("m:hidden");
      } else {
        el.classList.add("m:hidden");
      }
    });
    if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
      window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {
        ...cart, source: "ecomhard-definer-vip",
      });
    }
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart, source: "ecomhard-definer-vip" } }));

    if (openDrawer) {
      if (drawer && typeof drawer.open === "function") drawer.open();
      else window.location.assign(routes.cartPage);
    }
  };

  const updateSelectedVariant = (id) => {
    const variant = variantsById.get(String(id));
    if (!variant || !variant.available) return;
    selectedVariant = variant;
    elements.color.textContent = variant.name;
    elements.price.textContent = variant.priceFormatted || "";
    if (elements.image && variant.image) {
      elements.image.src = variant.image;
      elements.image.hidden = false;
    }
    elements.button.disabled = false;
    elements.error.hidden = true;
  };

  const clearSelection = () => {
    selectedVariant = null;
    elements.radios.forEach((radio) => { radio.checked = false; });
    elements.color.textContent = "Selecione uma cor";
    elements.price.textContent = config.variants.find((item) => item.available)?.priceFormatted || "";
    const firstImage = config.variants.find((item) => item.available && item.image)?.image;
    if (elements.image && firstImage) {
      elements.image.src = firstImage;
      elements.image.hidden = false;
    }
    elements.button.disabled = true;
    if (elements.error) elements.error.hidden = true;
  };

  const openModal = () => {
    if (activeModal || adding) return;
    clearSelection();
    lastFocusedElement = document.activeElement;
    rootElement.classList.add("is-open");
    rootElement.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("ecomhard-definer-vip-scroll-lock");
    activeModal = true;
    elements.dialog.scrollTop = 0;
    elements.dialog.focus({ preventScroll: true });
    updateModalAvailability();
  };

  const closeModal = (dismiss = false) => {
    if (!activeModal) return;
    rootElement.classList.remove("is-open");
    rootElement.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("ecomhard-definer-vip-scroll-lock");
    activeModal = false;
    if (dismiss) {
      dismissedThisPage = true;
      storage.set(dismissedKey, "1");
    }
    if (lastFocusedElement && typeof lastFocusedElement.focus === "function") {
      try { lastFocusedElement.focus({ preventScroll: true }); } catch (_) { /* Foco anterior indisponível. */ }
    }
  };

  const doSync = async () => {
    if (syncing || adding) { pendingSync = true; return; }
    syncing = true;
    try {
      const cart = await fetchCart();
      const qualified = balmQty(cart) >= Number(config.requiredQuantity || 2);
      const campaignGifts = giftItems(cart);
      if (!campaignActive()) {
        // Sem o link, não abrir modal; mas evitar manter brinde VIP inválido.
        if (!qualified && campaignGifts.length) {
          for (const item of campaignGifts) {
            await postCart(routes.change, { id: item.key, quantity: 0 });
          }
          await refreshCartUI(await fetchCart());
        }
        return;
      }

      if (!qualified) {
        if (activeModal) closeModal(false);
        if (lastQualified !== false) {
          storage.remove(dismissedKey);
          dismissedThisPage = false;
        }
        lastQualified = false;

        // Remove apenas os Definers marcados por ESTA campanha, nunca outros produtos da cliente.
        if (campaignGifts.length) {
          for (const item of campaignGifts) {
            await postCart(routes.change, { id: item.key, quantity: 0 });
          }
          await refreshCartUI(await fetchCart());
        }
        return;
      }

      lastQualified = true;
      if (campaignGifts.length) {
        if (activeModal) closeModal(false);
        return;
      }
      if (!dismissedThisPage && storage.get(dismissedKey) !== "1") openModal();
    } catch (error) {
      console.error("[ECOMHARD] Definer grátis: erro ao verificar a oferta.", error);
    } finally {
      syncing = false;
      if (pendingSync) {
        pendingSync = false;
        scheduleSync(160);
      }
    }
  };

  function scheduleSync(delay = 130) {
    clearTimeout(syncTimer);
    syncTimer = window.setTimeout(doSync, delay);
  }

  const addGift = async () => {
    if (adding || !selectedVariant) return;
    adding = true;
    elements.button.disabled = true;
    elements.button.setAttribute("aria-busy", "true");
    elements.error.hidden = true;
    const originalLabel = elements.button.textContent;
    elements.button.textContent = "Adicionando...";

    try {
      const cartBefore = await fetchCart();
      if (!campaignActive()) throw new Error("Acesso à campanha VIP não identificado.");
      if (!selectedVariant.available || Number(selectedVariant.priceCents) !== 0) {
        throw new Error("A variante do brinde precisa estar disponível e custar R$ 0,00.");
      }
      if (balmQty(cartBefore) < Number(config.requiredQuantity || 2)) {
        closeModal(false);
        throw new Error("A promoção exige dois balms no carrinho.");
      }
      // Segurança contra adição repetida com duplo clique ou carrinho alterado em outra aba.
      if (!giftItems(cartBefore).length) {
        await postCart(routes.add, {
          items: [{ id: Number(selectedVariant.id), quantity: 1,
            properties: { _ecomhard_definer_vip: campaignId } }],
        });
      }
      const cartAfter = await fetchCart();
      if (!giftItems(cartAfter).length) throw new Error("O brinde não foi encontrado no carrinho.");

      dismissedThisPage = true;
      storage.set(dismissedKey, "1");
      closeModal(false);
      await refreshCartUI(cartAfter, true);
    } catch (error) {
      console.error("[ECOMHARD] Definer grátis: erro ao adicionar brinde.", error);
      if (activeModal) {
        elements.error.hidden = false;
        elements.error.textContent = configuredErrorMessage || "Não foi possível adicionar o brinde. Tente novamente.";
      } else {
        notification(error.message || "Não foi possível adicionar o brinde. Tente novamente.");
      }
    } finally {
      adding = false;
      elements.button.removeAttribute("aria-busy");
      elements.button.textContent = originalLabel;
      elements.button.disabled = !selectedVariant;
      scheduleSync(230);
    }
  };

  // Delegação: as bolinhas são reconstruídas quando a Shopify fornece variantes.
  if (elements.colors) elements.colors.addEventListener("change", (event) => {
    if (event.target.matches('input[name="ecomhard-definer-vip-variant"]') && event.target.checked) {
      updateSelectedVariant(event.target.value);
    }
  });
  elements.closeButtons.forEach((button) => button.addEventListener("click", () => {
    if (!adding) closeModal(true);
  }));
  elements.button.addEventListener("click", addGift);

  document.addEventListener("keydown", (event) => {
    if (!activeModal) return;
    if (event.key === "Escape" && !adding) {
      event.preventDefault();
      closeModal(true);
      return;
    }
    if (event.key === "Tab") {
      const candidates = [...elements.dialog.querySelectorAll('button:not(:disabled), input:not(:disabled), [href], [tabindex]:not([tabindex="-1"])')]
        .filter((element) => element.getClientRects().length > 0);
      if (!candidates.length) { event.preventDefault(); return; }
      const first = candidates[0];
      const last = candidates[candidates.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === elements.dialog)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || document.activeElement === elements.dialog)) {
        event.preventDefault(); first.focus();
      }
    }
  });

  // Os eventos nativos do tema são emitidos pela PDP, quick view e atualizações do carrinho.
  document.addEventListener("product-ajax:added", () => scheduleSync(120));
  document.addEventListener("cart:updated", () => scheduleSync(100));
  document.addEventListener("cart:update-finished", () => scheduleSync(120));
  document.addEventListener("cart:change", () => scheduleSync(180));
  // Também monitorar carrinhos que avisam apenas que o drawer foi aberto.
  // A checagem consulta o carrinho REAL; nunca dispara pop-up antes de adicionar o balm.
  if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.openCartDrawer) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.openCartDrawer, () => scheduleSync(260));
  }
  window.addEventListener("pageshow", () => scheduleSync(100));

  if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
    window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, () => scheduleSync(170));
  }

  // Fallback para formulários Ajax personalizados que não publicam eventos do Minimog.
  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!(form.matches('[data-type="add-to-cart-form"]') || form.closest("product-form"))) return;
    window.setTimeout(() => scheduleSync(100), 600);
    window.setTimeout(() => scheduleSync(100), 1350);
  }, true);

  // Diagnóstico simples para conferir integração e elegibilidade sem alterar o carrinho.
  window.EcomhardDefinerVip = {
    status: async () => {
      const cart = await fetchCart();
      return {
        moduloCarregado: true,
        campanhaAtiva: campaignActive(),
        linkDetectado: visitedViaLink,
        fonteProduto: giftDataSource,
        carregandoProduto: giftLoading,
        erroProduto: giftError,
        variantes: config.variants.map((v) => ({ id: v.id, cor: v.name, disponivel: v.available, preco: v.priceCents })),
        balmId: config.balmProductId,
        definerId: config.giftProductId,
        handleBrinde: config.giftHandle,
        handleResolvidoPeloLiquid: config.giftHandleResolved || "",
        identificacao: "?eternal_black_vip=1",
        aplicaCupom: false,
        quantidadeBalms: balmQty(cart),
        quantidadeNecessaria: Number(config.requiredQuantity || 2),
        brindesVip: giftItems(cart).length,
        popupAberto: activeModal,
      };
    },
    verificar: () => scheduleSync(0),
  };

  // A ativação do link já ocorreu. Buscar o produto não listado nunca bloqueia a abertura.
  if (campaignActive()) void loadGiftData();
  scheduleSync(60);
})();
